/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionnairePossibleAnswer } from './QuestionnairePossibleAnswer';
import {
    QuestionnairePossibleAnswerFromJSON,
    QuestionnairePossibleAnswerFromJSONTyped,
    QuestionnairePossibleAnswerToJSON,
    QuestionnairePossibleAnswerToJSONTyped,
} from './QuestionnairePossibleAnswer';
import type { QuestionnaireQuestionImage } from './QuestionnaireQuestionImage';
import {
    QuestionnaireQuestionImageFromJSON,
    QuestionnaireQuestionImageFromJSONTyped,
    QuestionnaireQuestionImageToJSON,
    QuestionnaireQuestionImageToJSONTyped,
} from './QuestionnaireQuestionImage';

/**
 * 
 * @export
 * @interface QuestionnaireQuestion
 */
export interface QuestionnaireQuestion {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireQuestion
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireQuestion
     */
    order: number;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireQuestion
     */
    label?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireQuestion
     */
    text?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionnaireQuestion
     */
    multipleAllowed: boolean;
    /**
     * 
     * @type {Array<QuestionnaireQuestionImage>}
     * @memberof QuestionnaireQuestion
     */
    images?: Array<QuestionnaireQuestionImage> | null;
    /**
     * 
     * @type {Array<QuestionnairePossibleAnswer>}
     * @memberof QuestionnaireQuestion
     */
    answers?: Array<QuestionnairePossibleAnswer> | null;
}

/**
 * Check if a given object implements the QuestionnaireQuestion interface.
 */
export function instanceOfQuestionnaireQuestion(value: object): value is QuestionnaireQuestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('order' in value) || value['order'] === undefined) return false;
    if (!('multipleAllowed' in value) || value['multipleAllowed'] === undefined) return false;
    return true;
}

export function QuestionnaireQuestionFromJSON(json: any): QuestionnaireQuestion {
    return QuestionnaireQuestionFromJSONTyped(json, false);
}

export function QuestionnaireQuestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionnaireQuestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'order': json['order'],
        'label': json['label'] == null ? undefined : json['label'],
        'text': json['text'] == null ? undefined : json['text'],
        'multipleAllowed': json['multipleAllowed'],
        'images': json['images'] == null ? undefined : ((json['images'] as Array<any>).map(QuestionnaireQuestionImageFromJSON)),
        'answers': json['answers'] == null ? undefined : ((json['answers'] as Array<any>).map(QuestionnairePossibleAnswerFromJSON)),
    };
}

export function QuestionnaireQuestionToJSON(json: any): QuestionnaireQuestion {
    return QuestionnaireQuestionToJSONTyped(json, false);
}

export function QuestionnaireQuestionToJSONTyped(value?: QuestionnaireQuestion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'order': value['order'],
        'label': value['label'],
        'text': value['text'],
        'multipleAllowed': value['multipleAllowed'],
        'images': value['images'] == null ? undefined : ((value['images'] as Array<any>).map(QuestionnaireQuestionImageToJSON)),
        'answers': value['answers'] == null ? undefined : ((value['answers'] as Array<any>).map(QuestionnairePossibleAnswerToJSON)),
    };
}

